import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormModalBaseComponent } from '../../../../../core/base/components/form-modal-base/form-modal-base.component';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { EnergyIdService } from '../energy-id.service';
import { EstablishmentService } from '../../establishment/establishment.service';
import { EstablishmentModel } from '../../../../../core/models/establishment.model';
import { ObjectApiInterface } from '../../../../../core/base/interfaces/object-api.interface';
import { BuildingService } from '../../building/building.service';
import { BuildingModel } from '../../../../../core/models/building.model';
import { Observable, Subscription } from 'rxjs';
import { ResponseTypeEnum } from '../../../../../core/base/enum/response-type.enum';
import { CrudModeEnum } from '../../../../../core/base/enum/crud-mode.enum';
import { EnergyIdModel } from '../../../../../core/models/energy-id.model';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { GenericEnergyIdService } from '../../../settings/generic-energy-id/generic-energy-id.service';
import { GenericEnergyIdModel } from '../../../../../core/models/generic-energy-id.model';
import {
  GenericEnergyIdFormatEnum,
  GenericEnergyIdRestrictEnum,
  GenericEnergyIdTypeEnergyEnum,
} from '../../../../../core/enums/generic-energy-id.enum';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { SnackbarService } from '../../../../../core/services/snackbar.service';
import { ENUM_PERMISSIONS } from '../../../../../core/enums/permission.enum';
import { AuthService } from '../../../../../core/services/auth.service';
import { AutocompleteService } from '../../../../../core/services/scroll.service';
import { SupplierService } from '../../supplier/supplier.service';
import { SupplierModel } from '../../../../../core/models/supplier.model';

@Component({
  selector: 'vex-energy-id-create-update-delete',
  templateUrl: './energy-id-create-update-delete.component.html',
  styleUrls: ['./energy-id-create-update-delete.component.scss'],
})
export class EnergyIdCreateUpdateDeleteComponent extends FormModalBaseComponent<EnergyIdModel> implements OnInit {
  genericEnergyIds$: Observable<GenericEnergyIdModel[]>;
  buildings$: Observable<BuildingModel[]>;
  suppliers$: Observable<SupplierModel[]>;
  defaultCustomFieldLabel = "Choisissez d'abord un type d'énergie";
  customFieldLabel = this.defaultCustomFieldLabel;
  energyIdIdCustomError = null;
  isIDEnergyAlreayExist = false;
  itemCtrl = new UntypedFormControl();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  isDuplicate = false;

  establishmentsOfBuilding: EstablishmentModel[] = [];
  favoriteBuildings: BuildingModel[] = [];
  uniqueEstablishmentsSet = new Set<EstablishmentModel>();
  isRequireBuilding = false;
  lastBuildingSearch: string = '';
  private buildingSearchSub: Subscription;
  @ViewChild('itemInput') itemInputBuilding: ElementRef<HTMLInputElement>;

  canDownloadTemplateModel = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<FormModalBaseComponent<EnergyIdModel>>,
    private genericEnergyIdService: GenericEnergyIdService,
    public service: EnergyIdService,
    public establishmentService: EstablishmentService,
    public buildingService: BuildingService,
    private snackBarService: SnackbarService,
    public authService: AuthService,
    private autoCompleteService: AutocompleteService,
    private supplierService: SupplierService,
  ) {
    super(data, dialogRef, service);
  }

  ngOnInit() {
    this.checkPermission();
    super.ngOnInit();
    this._initForm();
    this._initData();
    this.lastBuildingSearch = '';
    this.onAutocompleteInput();
    this.genericEnergyIdsAutoCompleteChange();
  }

  beforeCreateItem() {
    this.defaults.buildings = this.form.get('buildings').value;
    if (this.defaults.buildings.length <= 0) {
      this.isRequireBuilding = true;
    }
  }

  beforeUpdateItem() {
    super.beforeUpdateItem();
    this.defaults._id = this.data.defaults._id;
    if (this.defaults.buildings.length <= 0) {
      this.isRequireBuilding = true;
    }
  }

  createItem(): void {
    this.loading = true;

    // Mark all fields as touched to show validation errors
    this.form.markAllAsTouched();

    // Check if form is valid (note: disabled controls are not validated)
    const formValue = this.form.getRawValue();

    // Manual validation check for disabled fields that should have values
    const isEnergyIdIdValid =
      this.getFormControl('energyIdId').disabled || (this.getFormControl('energyIdId').valid && formValue.energyIdId);

    if (!this.form.valid || !isEnergyIdIdValid) {
      this.onFormInvalid();
      this.loading = false;
      return;
    }

    this.defaults = formValue;
    this.beforeCreateItem();

    const sub = this.service.create(this._parseData(this.defaults)).subscribe(
      result => {
        this.afterCreateItem(result, null);
        this.setSnackbar(ResponseTypeEnum.Success, CrudModeEnum.Create, result.message);
      },
      error => {
        console.log(error, 'error');
        if (error.error?.statusCode === 5501) {
          this.isIDEnergyAlreayExist = true;
          this.energyIdIdCustomError = `Cet ID Energie existe déjà pour ce type d\'énergie`;
        }

        this.afterCreateItem(null, error);
        this.setErrorsMessages(error.error?.errors);
        this.loading = false;
      },
    );
    this.subscription.add(sub);
  }

  private getFormErrors(): any {
    const errors: any = {};
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      if (control && control.errors) {
        errors[key] = control.errors;
      }
    });
    return errors;
  }

  updateItem(): void {
    this.loading = true;

    // Mark all fields as touched to show validation errors
    this.form.markAllAsTouched();

    if (!this.form.valid) {
      console.log('Form invalid:', this.form);
      console.log('Form errors:', this.getFormErrors());
      this.onFormInvalid();
      this.loading = false;
      return;
    }

    this.defaults = this.form.getRawValue();
    this.beforeUpdateItem();

    if (this.isUpdateMode() && this.establishmentsOfBuilding.length <= 0) {
      this.data.establishments = this.defaults.establishments?.map(establishment => establishment._id) ?? null;
      this.establishmentsOfBuilding = this.defaults.establishments;
      this.establishmentsOfBuilding.length === 0 ? (this.establishmentsOfBuilding = this.data.establishments) : null;
    }

    const sub = this.service.update(this._parseData(this.defaults)).subscribe(
      result => {
        this.afterUpdateItem(result, null);
        this.setSnackbar(ResponseTypeEnum.Success, CrudModeEnum.Update, result.message);
      },
      error => {
        if (error.error?.statusCode === 5501) {
          this.isIDEnergyAlreayExist = true;
          this.energyIdIdCustomError = `Cet ID Energie existe déjà pour ce type d\'énergie`;
        }

        this.afterUpdateItem(null, error);
        this.setErrorsMessages(error.error?.errors);
        this.loading = false;
      },
    );
    this.subscription.add(sub);
  }

  importItems() {
    const isImporting = true;
    const importStartTime = Date.now();

    this.importDefaults = this.importForm.value;
    this.beforeImportItem();
    if (this.importForm.valid) {
      this.loading = true;
      const sub = this.service.importItems(this.importDefaults).subscribe(
        result => {
          this.afterImportItem(result, null);
          this.setSnackbar(ResponseTypeEnum.Success, CrudModeEnum.Import, result.message);
        },
        error => {
          this.afterImportItem(null, error);
          this.setImportErrorsMessages(error.error.errors);
          this.loading = false;
        },
      );

      setTimeout(() => {
        if (isImporting && !sub.closed) {
          const importDuration = Date.now() - importStartTime;
          if (importDuration >= 2000) {
            this.snackbarService.warning("L'importation peut prendre quelques secondes. Veuillez patienter.", 15000);
          }
        }
      }, 2000);

      this.subscription.add(sub);
    } else {
      this.onFormInvalid();
      this.form.markAllAsTouched();
      this.loading = false;
    }
  }

  onFormInvalid() {
    super.onFormInvalid();
  }

  afterCreateItem(result?: any, error?: any) {
    if (result) {
      this.close(result.data);
    }
  }

  afterUpdateItem(result?: any, error?: any) {
    if (result) {
      this.close(true);
    }
  }

  afterImportItem(result?: any, error?: any) {
    if (result) {
      this.close(true);
    }
  }

  private _initForm() {
    // Custom validator for array minimum length
    const minArrayLength = (min: number): ValidatorFn => {
      return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value && Array.isArray(control.value) && control.value.length >= min) {
          return null;
        }
        return { minArrayLength: { requiredLength: min, actualLength: control.value?.length || 0 } };
      };
    };

    if (this.isCreateMode()) {
      this.form = new UntypedFormGroup({
        genericEnergyId: new UntypedFormControl(null, Validators.required),
        energyIdId: new UntypedFormControl(null, Validators.required),
        buildings: new UntypedFormControl([], [Validators.required, minArrayLength(1)]),
        establishments: new UntypedFormControl([]),
        favoriteBuilding: new UntypedFormControl(null, Validators.required),
        additionalInfo: new UntypedFormControl(null, [Validators.maxLength(50)]),
        supplier: new UntypedFormControl(null),
      });
    }
    if (this.isUpdateMode()) {
      // PRED-3076 : ne pas réinjecter un favoriteBuilding corrompu (relation fantôme sans label),
      // sinon il est resauvegardé tel quel et le champ paraît rempli alors qu'il est vide
      const sanitizedFavoriteBuilding =
        this.defaults.favoriteBuilding?._id && this.defaults.favoriteBuilding?.label
          ? this.defaults.favoriteBuilding
          : null;

      this.form = new UntypedFormGroup({
        genericEnergyId: new UntypedFormControl(
          this.defaults.genericEnergyId ? this.defaults.genericEnergyId : null,
          Validators.required,
        ),
        energyIdId: new UntypedFormControl(
          this.defaults.energyIdId ? this.defaults.energyIdId : null,
          Validators.required,
        ),
        buildings: new UntypedFormControl(this.defaults.buildings ? this.defaults.buildings : [], [
          Validators.required,
          minArrayLength(1),
        ]),
        establishments: new UntypedFormControl(this.defaults.establishments ? this.defaults.establishments : []),
        favoriteBuilding: new UntypedFormControl(sanitizedFavoriteBuilding, Validators.required),
        additionalInfo: new UntypedFormControl(this.defaults.additionalInfo ? this.defaults.additionalInfo : null, [
          Validators.maxLength(50),
        ]),
        supplier: new UntypedFormControl(this.defaults.supplier ? this.defaults.supplier : null),
      });

      this.form.get('genericEnergyId').valueChanges.subscribe(val => {
        this.form.get('energyIdId').setValue(null);
      });

      this.favoriteBuildings = this.form.get('buildings').value;

      // En mode update, si le PDL a déjà des establishments, on les utilise
      if (this.defaults.establishments && this.defaults.establishments.length > 0) {
        this.establishmentsOfBuilding = this.defaults.establishments;
      }

      this.updateEstablishments(this.defaults.buildings || [], { preserveSelection: true });
    }

    if (this.isCustomMode()) {
      this.form = new UntypedFormGroup({
        genericEnergyId: new UntypedFormControl(
          this.defaults?.genericEnergyId ? this.defaults.genericEnergyId : null,
          Validators.required,
        ),
        energyIdId: new UntypedFormControl(
          this.defaults?.energyIdId ? this.defaults.energyIdId : null,
          Validators.required,
        ),
        buildings: new UntypedFormControl(this.defaults?.buildings ? this.defaults?.buildings[0] : []),
        establishments: new UntypedFormControl(this.defaults?.establishments ? this.defaults.establishments : []),
        favoriteBuilding: new UntypedFormControl(
          this.defaults?.favoriteBuilding ? this.defaults.favoriteBuilding : null,
          Validators.required,
        ),
        additionalInfo: new UntypedFormControl(this.defaults?.additionalInfo ? this.defaults.additionalInfo : null, [
          Validators.maxLength(50),
        ]),
        supplier: new UntypedFormControl(this.defaults?.supplier ? this.defaults.supplier : null),
      });

      this.favoriteBuildings = this.form.get('buildings').value;
    }

    // we disable energyIdId by default because it will be enabled when genericEnergyId is chosen
    if (this.isCreateMode()) {
      this.getFormControl('energyIdId').disable({
        onlySelf: true,
        emitEvent: false,
      });
    }

    if (this.isUpdateMode()) {
      this.getFormControl('energyIdId').enable({
        onlySelf: true,
        emitEvent: false,
      });
    }

    if (this.isCustomMode()) {
      this.getFormControl('energyIdId').disable({
        onlySelf: true,
        emitEvent: false,
      });
    }

    // Trigger events based on changes of form
    this.subscription.add(
      this.form.valueChanges
        .pipe(
          debounceTime(100),
          distinctUntilChanged((prev, curr) => {
            // Comparer uniquement les champs qui nous intéressent
            const prevBuildingIds =
              prev?.buildings
                ?.map(b => b._id)
                .sort()
                .join(',') || '';
            const currBuildingIds =
              curr?.buildings
                ?.map(b => b._id)
                .sort()
                .join(',') || '';
            const prevGenericId = prev?.genericEnergyId?._id || '';
            const currGenericId = curr?.genericEnergyId?._id || '';
            return prevBuildingIds === currBuildingIds && prevGenericId === currGenericId;
          }),
        )
        .subscribe(val => {
          const genericEnergyId: GenericEnergyIdModel = this.form.getRawValue()?.genericEnergyId;
          const buildings = val?.buildings;
          this.isIDEnergyAlreayExist = false;

          // Comparer les IDs des bâtiments pour éviter les appels inutiles
          const buildingIds =
            buildings
              ?.map(b => b._id)
              .sort()
              .join(',') || '';
          const favoriteBuildingIds =
            this.favoriteBuildings
              ?.map(b => b._id)
              .sort()
              .join(',') || '';
          if (buildings && buildingIds !== favoriteBuildingIds) {
            this.updateEstablishments(buildings, { preserveSelection: this.isUpdateMode() });
          }

          if (genericEnergyId && this.getFormControl('genericEnergyId')?.valid) {
            const energyIdIdFormControl: AbstractControl = this.getFormControl('energyIdId');

            // Set custom field label depending on chosen generic energy id
            this.customFieldLabel = genericEnergyId.fieldLabel;

            // Then set the validators depending on the generic energy id chosen
            const validators: ValidatorFn[] = [];

            if (genericEnergyId.format !== GenericEnergyIdFormatEnum.NO_RESTRICTION) {
              this.energyIdIdCustomError = null;

              switch (genericEnergyId.restrict) {
                case GenericEnergyIdRestrictEnum.FIXED:
                  validators.push(Validators.minLength(genericEnergyId.charactersNumber));
                  validators.push(Validators.maxLength(genericEnergyId.charactersNumber));
                  validators.push(Validators.required);
                  this.energyIdIdCustomError = `Le format de l'identifiant doit être de ${genericEnergyId.charactersNumber} caractères`;
                  break;
                case GenericEnergyIdRestrictEnum.MAX:
                  validators.push(Validators.maxLength(genericEnergyId.charactersNumber));
                  validators.push(Validators.required);
                  this.energyIdIdCustomError = `Le format de l'identifiant doit être de maximum ${genericEnergyId.charactersNumber} caractères`;
                  break;
              }

              switch (genericEnergyId.format) {
                case GenericEnergyIdFormatEnum.ALPHANUMERIC:
                  validators.push(Validators.pattern('^[a-zA-Z0-9]+$'));
                  this.energyIdIdCustomError += "\nL'identifiant doit être alphanumérique";
                  break;
                case GenericEnergyIdFormatEnum.NUMERIC:
                  validators.push(Validators.pattern('^[0-9]+$'));
                  this.energyIdIdCustomError += "\nL'identifiant doit être numérique";
                  break;
              }

              energyIdIdFormControl.setValidators(validators);
              energyIdIdFormControl.updateValueAndValidity({
                onlySelf: true,
                emitEvent: false,
              });
            } else {
              energyIdIdFormControl.setValidators([Validators.required]);
            }

            // Finally we enable the field
            energyIdIdFormControl.enable({
              onlySelf: true,
              emitEvent: false,
            });
          } else {
            // If for some reason the generic energy id is unselected, we make sure that energyIdId is reset
            const energyIdIdFormControl: AbstractControl = this.getFormControl('energyIdId');

            // First we disable it
            energyIdIdFormControl.disable({
              onlySelf: true,
              emitEvent: false,
            });

            // Then we reset its label, validators and value
            this.customFieldLabel = this.defaultCustomFieldLabel;
            energyIdIdFormControl.clearValidators();
            energyIdIdFormControl.updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
            energyIdIdFormControl.setValue(null, {
              onlySelf: true,
              emitEvent: false,
            });
          }
        }),
    );
  }

  getFormControl(controlName: string): AbstractControl {
    return this.form.get(controlName);
  }

  private _initData() {
    this.genericEnergyIds$ = this.genericEnergyIdService
      .findAll()
      .pipe(map((x: ObjectApiInterface<GenericEnergyIdModel[]>) => x.data));
    this.autoCompleteSupplier();
  }

  private _parseData(defaults: EnergyIdModel) {
    const buildings = this.isCustomMode() ? [defaults.buildings] : defaults.buildings;

    const data: any = {
      genericEnergyId: defaults.genericEnergyId?._id,
      energyIdId: defaults.energyIdId,
      buildings: buildings?.map(building => building._id) ?? null,
      establishments: defaults.establishments?.map(establishment => establishment._id) ?? null,
      favoriteBuilding: defaults.favoriteBuilding?._id,
      additionalInfo: defaults.additionalInfo,
      supplier: defaults.supplier?._id ?? null,
    };

    this.isUpdateMode() ? (data._id = defaults._id) : null;
    return data;
  }

  genericEnergyIdsAutoCompleteChange(state = '') {
    this.genericEnergyIds$ = this.genericEnergyIdService
      .findAll(null, null, null, null, state, null)
      .pipe(map((x: ObjectApiInterface<GenericEnergyIdModel[]>) => x.data));
  }

  autoCompleteSupplier(state?: string) {
    this.suppliers$ = this.supplierService
      .findAll(null, null, 'label', 'asc', state)
      .pipe(map((x: ObjectApiInterface<SupplierModel[]>) => x.data));
  }

  updateEstablishments(buildings: any[], options: { preserveSelection?: boolean } = {}) {
    const establishmentFormControl = this.getFormControl('establishments');
    const preserveSelection = options.preserveSelection ?? false;

    // Convertir buildings en tableau si c'est un objet unique (mode Custom)
    const buildingsArray = Array.isArray(buildings) ? buildings : buildings ? [buildings] : [];

    if (!buildingsArray || buildingsArray.length === 0) {
      this.establishmentsOfBuilding = [];
      establishmentFormControl.setValue([], { emitEvent: false });
      establishmentFormControl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      this.favoriteBuildings = [];
      return;
    }

    const uniqueEstablishments = new Map();

    // En mode update, on commence par garder les establishments existants du PDL
    if (this.isUpdateMode() && this.defaults.establishments) {
      this.defaults.establishments.forEach(establishment => {
        uniqueEstablishments.set(establishment._id, establishment);
      });
    }

    // Puis on ajoute les establishments des bâtiments
    buildings.forEach(building => {
      if (building.establishments && Array.isArray(building.establishments)) {
        building.establishments.forEach(establishment => {
          uniqueEstablishments.set(establishment._id, establishment);
        });
      }
    });

    this.establishmentsOfBuilding = Array.from(uniqueEstablishments.values());

    const currentSelection: EstablishmentModel[] = Array.isArray(establishmentFormControl.value)
      ? establishmentFormControl.value
      : [];

    const shouldAutoSelectAll = !preserveSelection && currentSelection.length === 0;
    let nextSelection: EstablishmentModel[] = [];

    if (shouldAutoSelectAll) {
      nextSelection = [...this.establishmentsOfBuilding];
    } else if (preserveSelection) {
      // En mode update avec preserveSelection, on garde tous les establishments disponibles
      // car establishmentsOfBuilding contient déjà la fusion (PDL + bâtiments)
      nextSelection = [...this.establishmentsOfBuilding];
    } else {
      const selectedMap = new Map(currentSelection.map(establishment => [establishment._id, establishment]));
      nextSelection = this.establishmentsOfBuilding.filter(establishment => selectedMap.has(establishment._id));
    }

    establishmentFormControl.setValue(nextSelection, { emitEvent: false });
    establishmentFormControl.updateValueAndValidity({ onlySelf: true, emitEvent: false });

    this.isRequireBuilding = false;
    this.favoriteBuildings = buildingsArray;
  }

  autocompleteBuildingsSearch(search: string = '', pageToGo?: 'next' | 'previous'): void {
    // Si c'est une nouvelle recherche (pas juste un scroll), réinitialiser les données
    if (!pageToGo && search !== this.lastBuildingSearch) {
      this.autoCompleteService.resetItem('buildings');
      // Annuler la requête précédente uniquement pour les nouvelles recherches
      this.buildingSearchSub?.unsubscribe();
    }
    this.lastBuildingSearch = search;

    this.buildingSearchSub = this.autoCompleteService
      .autocompleteInfiniteScroll(search, 'buildings', '_id', pageToGo, (page, size, filterName, searchParam) =>
        this.buildingService.findAll(page, size, 'label', 'asc', searchParam, {
          isInUserAffectations: true,
          excludeItemsWithoutEstablishments: true,
          requiredFields: ['*'],
          isArchive: false,
          isDelete: false,
        }),
      )
      ?.subscribe();
  }

  onAutocompleteInput(event?: Event, pageToGo?: 'next' | 'previous'): void {
    // En cas de scroll, conserver le terme de recherche actuel
    const inputValue = pageToGo ? this.lastBuildingSearch : ((event?.target as HTMLInputElement)?.value ?? '');
    this.autocompleteBuildingsSearch(inputValue, pageToGo);
  }

  checkPermission() {
    this.subscription.add(
      this.authService.getCurrentUserPermissions$().subscribe(permissions => {
        if (permissions.includes(ENUM_PERMISSIONS.READ_ENERGY_ID)) {
          this.canDownloadTemplateModel = true;
        }
      }),
    );
  }

  genericBuildingsAutoCompleteChange(state: any) {
    this.buildings$ = this.buildingService
      .findAll(null, null, null, null, state, {
        isArchive: false,
        isDelete: false,
      })
      .pipe(map((x: ObjectApiInterface<BuildingModel[]>) => x.data));
  }

  onSelectBuildings(event: Array<BuildingModel>): void {
    this.updateEstablishments(event, { preserveSelection: this.isUpdateMode() });
  }

  onScrollLine(pageToGo: 'next' | 'previous', filterField: string): void {
    switch (filterField) {
      case 'buildings':
        this.onAutocompleteInput(null, pageToGo);
        break;
    }
  }

  getItems$(key: string): Observable<any[]> {
    return this.autoCompleteService.getItems$(key);
  }
}
